<template>
  <vx-card :collapse-action="true" title="Filter">
    <div class="vx-row">
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <vs-input label="TRANSACTION ID" v-model="id" class="w-full" />
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <vs-input label="CUSTOMER ID" v-model="customerId" class="w-full" />
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">
          STATUS
        </label>
        <v-select
          :options="statuses"
          v-model="status"
          class="w-1/10 select-small"
        />
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">
          TYPES
        </label>
        <v-select
          :options="transTypes"
          v-model="type"
          class="w-1/10 select-small"
        />
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">
          EXPORTED
        </label>
        <v-select
          :options="exported"
          v-model="isExportFilter"
          class="w-1/10 select-small"
        />
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">
          DATE FROM
        </label>
        <vx-input-group class="mb-base">
          <datepicker
            :format="format"
            class="inputx"
            placeholder="From"
            v-model="dateFrom"
          ></datepicker>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="grey" type="border" @click="dateFrom = ''">X</vs-button>
            </div>
          </template>
        </vx-input-group>
      </div>

      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">
          DATE TO
        </label>
        <vx-input-group class="mb-base">
          <datepicker
            :format="format"
            class="inputx"
            placeholder="To"
            v-model="dateTo"
          ></datepicker>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="grey" type="border" @click="dateTo = ''">X</vs-button>
            </div>
          </template>
        </vx-input-group>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  import { statuses } from "@/constants/transaction-statuses";
  import Datepicker from "vuejs-datepicker";
  import SearchSelect from "@/views/components/override/SearchSelect";
  import * as moment from "moment/moment";
  import {transTypes} from "@/constants/transaction-types";

  export default {
    components: {
      'v-select': vSelect,
      Datepicker,
      SearchSelect,
    },
    watch: {
      id: function (val) {
        this.emitChange('id', '$contL', val);
      },
      customerId: function (val) {
        this.emitChange('customerId', '$contL', val);
      },
      status: function (val) {
        this.emitChange('status', '$eq', val ? val.key : "");
      },
      type: function(val){
        this.emitChange('type', '$eq', val ? val.key : "");
      },
      isExportFilter: function(val){
        this.emitChange('isExport', '$eq', val ? val.key : "");
      },
      dateFrom: function(val) {
        const firstSecondOfDay = moment(val);
        if (!firstSecondOfDay.isValid()) {
          this.emitChange('createdAt', '$gte', '');
          return ;
        }
        this.emitChange('createdAt', '$gte', firstSecondOfDay.format("YYYY-MM-DDT23:59:59.000") + "Z");
      },
      dateTo: function(val) {
        const lastSecondOfDay = moment(val);
        if (!lastSecondOfDay.isValid()) {
          this.emitChange('createdAt', '$lte', '');
          return ;
        }
        this.emitChange('createdAt', '$lte', lastSecondOfDay.format("YYYY-MM-DDT23:59:59.000") + "Z");
      },
    },
    methods: {
      emitChange(attribute, searchType, value) {
        const recordIndex = this.search.findIndex((search) => search[attribute] != undefined );
        if (recordIndex >= 0) {
          this.search.splice(recordIndex, 1)
        }
        if (value) {
          this.search.push({
            [attribute]: { [searchType]: value }
          });
        }
        this.refreshResult();
      },
      refreshResult() {
        this.timeout && window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
          this.$emit('change', {
            "$and": this.search,
          });
        }, 380);
      },
    },
    data () {
      return {
        format: "yyyy-MM-dd",
        id: null,
        customerId: null,
        status: null,
        dateFrom: null,
        dateTo: null,
        isExportFilter: null,
        exported: [
          { key: 'TRUE', label: 'Exported'},
          { key: 'FALSE', label: 'Not Exported'},
          { key: '', label: 'All' }
        ],
        statuses,
        transTypes,
        type: null,
        search: [],
      }
    },
  }
</script>
